export const dark = {
    colorTitle: '#fff',
    colorText: '#fff',
    widgetBg: '#0A0E20',
    btnShadow: '0 0 20px 0px rgba(237, 82, 82, 0.55)',
    btnBg: '#ED5252',
    btnColor: '#fff',
    btnHoverColor: '#fff',
    btnHoverBg: '#F06C6C',
    btnActiveBg: '#D54A4A',
    btnActiveColor: '#fff',
};
export const red = {
    colorTitle: '#303446',
    colorText: '#303446',
    widgetBg: '#fff',
    btnShadow: '0 0 20px 0px rgba(237, 82, 82, 0.55)',
    btnBg: '#ED5252',
    btnColor: '#fff',
    btnHoverColor: '#fff',
    btnHoverBg: '#F06C6C',
    btnActiveBg: '#D54A4A',
    btnActiveColor: '#fff',
};
export const yellow = {
    colorTitle: '#303446',
    colorText: '#303446',
    widgetBg: '#FFF06E',
    btnShadow: '0 10px 40px 0 rgba(0, 0, 0, 0.07)',
    btnBg: '#0A0E20',
    btnColor: '#fff',
    btnHoverColor: '#fff',
    btnHoverBg: '#4D5163',
    btnActiveBg: '#303446',
    btnActiveColor: '#fff',
};
